
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.307 1.085a.608.608 0 00-.43.178L4.83 6.31l-.287 1.147L5.69 7.17l5.047-5.047a.608.608 0 00-.43-1.038zM9.11.495a1.693 1.693 0 012.394 2.395L6.351 8.044a.542.542 0 01-.252.143l-2.17.542a.542.542 0 01-.658-.658l.542-2.17a.542.542 0 01.143-.252L9.11.496zM.477 1.628c.305-.305.719-.476 1.15-.476h3.798a.542.542 0 110 1.085H1.627a.542.542 0 00-.542.542v7.595a.542.542 0 00.542.542h7.595a.543.543 0 00.542-.542V6.575a.542.542 0 111.085 0v3.798A1.627 1.627 0 019.222 12H1.627A1.627 1.627 0 010 10.373V2.778c0-.431.171-.845.477-1.15z","fill":"#0D69D5"}})])
          )
        }
      }
    